import { ITradePricingPendingApproval } from "src/services/interface/pricing/ITradePricingPendingApproval";
import { ApiService } from "../../../model/Api.model";
import { AxiosInstance } from "axios";
import { ITradePricingApproval } from "src/services/interface/pricing/ITradePricingApproval";
import { IApprovalExcel } from "src/services/interface/pricing/IApprovalExcel";

enum TradePricingPendingApprovalEnum {
    get = '/',
    approve = '/approve',
    reject = '/reject',
    recoveyExtract = '/get-extract',
    downloadExcel = '/get-approval-report-excel'

}

export default class TradePricingPendingApprovalService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/pricing/trade/price/analysis");
    }

    public getAllTrades = async (): Promise<ITradePricingApproval[]> => await this.GET(TradePricingPendingApprovalEnum.get);
    public approve = async (tradePricingPendingId: number): Promise<ITradePricingPendingApproval> => await this.POST(`${TradePricingPendingApprovalEnum.approve}/${tradePricingPendingId}`, null);
    public reject = async (tradePricingPendingId: number, reason: string): Promise<ITradePricingPendingApproval> => await this.POST(`${TradePricingPendingApprovalEnum.reject}/${tradePricingPendingId}/${reason}`, null);
    public getExtract = async (tradeId?: number): Promise<string> => await this.GET(`${TradePricingPendingApprovalEnum.recoveyExtract}/${tradeId}`);
    public downloadExcel = async (): Promise<IApprovalExcel> => await this.GET(TradePricingPendingApprovalEnum.downloadExcel);
}



// WEBPACK FOOTER //
// ./src/services/api/Pricing/trade-pricing-pending/TradePricingPedingApproval.service.ts